import styles from "./MissedSession.module.scss";

import { Trans, useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";

type MissedSessionProps = {
  handleCancel?: () => void;
  handleReschedule?: () => void;
};

export const MissedSession = ({
  handleCancel,
  handleReschedule,
}: MissedSessionProps) => {
  const { t } = useTranslation();

  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>{t("missedSession.title")}</span>

        <Trans
          i18nKey="missedSession.description"
          components={{
            first: <p className={styles.description} />,
            second: <p className={styles.description} />,
            third: <p className={styles.description} />,
          }}
        />

        <div className={styles.footer}>
          <AppButton variant="outlined" onClick={handleCancel}>
            <span>{t("missedSession.buttons.cancel")}</span>
          </AppButton>

          <AppButton variant="outlined" onClick={handleReschedule}>
            <span className={styles.cancelSessionButton}>
              {t("missedSession.buttons.reschedule")}
            </span>
          </AppButton>
        </div>
      </div>
    </PageContainer>
  );
};
